import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: 'About Us',
    path: '/about',
    desc: 'Learn about our mission, our team of industry veterans, and how we are transforming enterprise connectivity.'
  },
  {
    title: 'Partners',
    path: '/partners',
    desc: 'Join the Sarvanta Elevate partner program and gain access to tools, training, and incentives to grow your business.'
  },
  {
    title: 'Contact',
    path: '/contact',
    desc: 'Get in touch with our team for demos, technical questions, or partnership inquiries.'
  },
  {
    title: 'News',
    path: '/news',
    desc: 'Stay up to date with the latest product announcements, company updates, and industry insights.'
  }
];

const Company = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Company</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          Founded in 2023 by veterans of Cisco, Comcast, Ruckus Wireless, Fujitsu, and Plume WiFi,
          Sarvanta is building the next generation of cloud-managed network infrastructure.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '24px' }}>
          {sections.map((section, i) => (
            <Link key={i} to={section.path} style={{
              padding: '32px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744', textDecoration: 'none', color: '#fff'
            }}>
              <h2 style={{ fontSize: '1.4rem', marginBottom: '12px', color: '#60a5fa' }}>{section.title}</h2>
              <p style={{ color: '#a0aec0', lineHeight: '1.7', margin: 0 }}>{section.desc}</p>
              <span style={{ color: '#2563eb', marginTop: '16px', display: 'inline-block', fontWeight: '600' }}>
                Learn more &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Company;
